<template>
    <div id="app" v-bind:lang="this.$i18n.locale">
        <router-view keep-alive/>
    </div>
</template>

<script>
    export default {
        name: "App",
        watch: {
            '$store.getters.locale'(newValue) {
                console.log("[App] Locale changed: ", newValue);
                this.$i18n.locale = newValue;
            }
        },
        beforeMount() {
            this.$store.dispatch("loadFAQs");
        },
        mounted() {
            this.$i18n.locale = this.$store.getters.locale;
            this.$communicator.trackPageImpression("FAQPage");
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/variables.scss";

    #app {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        margin-bottom: 15px;
        font-size: 17px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    h5 {
        @include fontHeadline($fontSize: 18px);
    }

    p {
        @include fontText($fontSize: 16px);
    }

    .chevron {
        svg {
            color: $lightgrey;
        }
    }

</style>